import React, { SetStateAction, useState } from "react";
import { FaSearch, FaTimesCircle } from "react-icons/fa";
import { Input } from "reactstrap";

import { blogSearch } from "@/utils/content";
import { useIsMobile } from "@/hooks/useIsMobile";
import { MdClose, MdOutlineSearch } from "react-icons/md";

type BlogSearchProps = {
  searchTerm: string;
  setSearchTerm: (value: SetStateAction<string>) => void;
  classes: any;
};

const BlogSearch = ({
  searchTerm,
  setSearchTerm,
  classes,
}: BlogSearchProps) => {
  const isMobile = useIsMobile();
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  const content = blogSearch.en;

  return (
    <main>
      <section className={classes.hero}>
        <div className="container">
          <div>
            <h1>{content.title}</h1>
          </div>
          <div
            className={`${isMobile ? "" : "w-50"} position-relative mx-auto`}
          >
            <Input
              disabled={loading}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  setSearchTerm(search);
                }
              }}
              placeholder={content.inputPlaceholder}
            />
            {!searchTerm && (
              <MdOutlineSearch className={classes.inputFloatIco} />
            )}
            {searchTerm && (
              <MdClose
                className={classes.inputFloatIco}
                onClick={() => {
                  setSearch("");
                  setSearchTerm("");
                }}
              />
            )}
          </div>
        </div>
      </section>
    </main>
  );
};

export default BlogSearch;
